<template>
  <header class="app-header">
    <div class="header-inner">
      <div
        class="push-status"
        :class="`push-status--${pushStatusMeta.tone}`"
        :title="pushStatus === 'online' ? pushStatusMeta.label : `${pushStatusMeta.label}（点击重连）`"
        role="button"
        @click="onPushStatusClick"
      >
        <span class="push-status__dot" aria-hidden="true" />
        <span class="push-status__text">{{ pushStatusMeta.label }}</span>
      </div>
      <router-link to="/profile" class="user-avatar" :title="userName">
        <img v-if="userAvatar" class="avatar-img" :src="userAvatar" alt="" />
        <span v-else class="avatar-text">{{ userInitial }}</span>
      </router-link>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader'
}
</script>

<script setup>
import { computed } from 'vue'
import { getUser } from '@/utils/auth'
import { useAuditMenuBadge } from '@/composables/useAuditMenuBadge'

const { pushStatus, pushStatusMeta, reconnectAuditRemind } = useAuditMenuBadge()

const user = computed(() => getUser())
const userName = computed(() => user.value?.name || '调度员')
const userAvatar = computed(() => user.value?.avatar || '')
const userInitial = computed(() => (userName.value[0] || '调').toUpperCase())

function onPushStatusClick() {
  if (pushStatus.value === 'online') return
  reconnectAuditRemind()
}</script>

<style scoped>
.app-header {
  position: fixed;
  top: 0;
  left: var(--sidebar-width);
  right: 0;
  z-index: 1000;
  height: var(--header-height);
  background: var(--bg-surface);
  border-bottom: 1px solid var(--border-color);
}

.header-inner {
  height: 100%;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.push-status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 28px;
  padding: 0 12px 0 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  user-select: none;
  cursor: pointer;
  transition: background 150ms var(--ease-out);
}

.push-status__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.push-status__text {
  white-space: nowrap;
}

.push-status--ok {
  color: #2e7d32;
  background: rgba(103, 194, 58, 0.12);
  cursor: default;
}

.push-status--ok .push-status__dot {
  background: #67c23a;
  box-shadow: 0 0 0 0 rgba(103, 194, 58, 0.5);
  animation: push-dot-pulse 1.8s ease-in-out infinite;
}

.push-status--warn {
  color: #b8821a;
  background: rgba(230, 162, 60, 0.12);
}

.push-status--warn .push-status__dot {
  background: #e6a23c;
  animation: push-dot-blink 1s ease-in-out infinite;
}

.push-status--danger {
  color: #c45656;
  background: rgba(245, 108, 108, 0.1);
}

.push-status--danger .push-status__dot {
  background: #f56c6c;
}

.push-status--muted {
  color: #909399;
  background: #f4f5f7;
}

.push-status--muted .push-status__dot {
  background: #c0c4cc;
}

@keyframes push-dot-pulse {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(103, 194, 58, 0.45);
  }
  50% {
    box-shadow: 0 0 0 6px rgba(103, 194, 58, 0);
  }
}

@keyframes push-dot-blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
}

.user-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  overflow: hidden;
  text-decoration: none;
  background: linear-gradient(135deg, #057bfa 0%, #0284c7 100%);
  flex-shrink: 0;
  border: 1px solid rgba(5, 123, 250, 0.2);
  transition: transform 150ms var(--ease-out), box-shadow 150ms var(--ease-out);
}

.user-avatar:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(5, 123, 250, 0.25);
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.avatar-text {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}
</style>
